import styled from 'styled-components';
import Colors from 'constants/Colors';
import { Text, QuicksandBold } from 'components/Text';


const Content = styled.div`
  background: ${Colors.WHITE};
  margin-top: 40px;
  border: 1px solid ${Colors.GREEN};
  background: #fff;
  margin-bottom: 60px;
  border-radius: 20px;
  box-shadow: 0px 17px 17px 6px #5f5f5f1a;
`;

const Heading = styled.div`
  background: ${Colors.GREEN};
  color: ${Colors.WHITE};
  padding: 17px 25px;
  font-weight: ${QuicksandBold};
  font-family:'Quicksand', sans-serif;
  text-transform: uppercase;
  font-size: 16px;
  border-radius: 15px 15px 0px 0px;
`;


const TitleChart = styled(Text)`
  font-size: 16px;
  display: block;
  margin-top: 30px;
  margin-left: 10px
`;

const TitleCalendar = styled(Text)`
  font-size: 16px;
  display: block;
  margin-top: 30px;
  margin-left: 10px
  margin-bottom: 20px;
`;

const Legend = styled.div`
  height: 60px;

  .content{
    p{
      width: 50%;
      display: inline-block;
      font-size: 13px;
      color: #777;
    }
    p:first-child{
      text-align: right;
    }
    span{
      width: 10px;
      height: 10px;
      margin-right: 5px;
      display: inline-block;
      margin-left: 10px;
    }
  }
`;

const Main = styled.div`
margin-left: 30px;
  margin-right: 0px;
  padding-right: 30px;
`;


export { Content, Heading, TitleChart, TitleCalendar, Legend, Main };
